import React from "react";
import RecessImage from "../../../Assets/Images/pix1.png";
import RecessImageTwo from "../../../Assets/Images/pix2.png";
import RecessImageThree from "../../../Assets/Images/pix3.png";
import FdSectionImage from "../../../Assets/Images/fax1.png";
import fieldDaysBanner from "../../../Assets/Images/field-days-banner2.png";
import fieldDaysBannerWeb from "../../../Assets/Images/field-days-banner-web.png";
import "./fielddayssection.css";

export default function FieldDaysSection() {
  return (
    <>
      <div className="fds-wrapper">
        <div className="fds-header-box">
          <img
            className="field-days-web"
            src={fieldDaysBannerWeb}
            alt="field_banner_web"
          />
          <img
            className="field-days-mobile"
            src={fieldDaysBanner}
            alt="field_banner"
          />
          {/* <div className='maxWidth-content stripe-w'>
                    <h2 style={{alignSelf:"center"}}>Field Days</h2>
                    <div className="fds-header-images">
                        <img src={RecessImage} alt="recess" />
                        <img src={RecessImageTwo} alt="recess" />
                        <img src={RecessImageThree} alt="recess" />
                    </div>
                    </div> */}
        </div>

        <div className="fds-content-box">
          <div className="fds-img-box">
            <img src={FdSectionImage} alt="fd-section" />
          </div>

          <div className="fds-text-box">
            <p className="black-text-clip">
              Get ready for an unforgettable day of fun, excitement, and
              adventure with our Field Day/Carnival packages! Perfect for
              schools looking to create lasting memories, our packages are
              designed to cater to both elementary and intermediate school
              students. With a variety of activities, a DJ, and hours of
              non-stop entertainment, there’s something for everyone!
            </p>

            <p className="black-text-clip">
              Don’t miss out on this incredible opportunity to bring joy,
              excitement, and team spirit to your students. Book your Field
              Day/Carnival today and let’s create a day they’ll never forget!
            </p>

            <p className="black-text-clip">
              For more information or to book now,{" "}
              <strong>contact us at (347) 212-0028.</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
